import { API, REPORT_API } from "../../../utils";

export const DownloadReportList = async (payload) => {
  const res = await REPORT_API.post(`reports`, payload);
  return res;
};
export const DownloadReportTableList = async (query) => {
  const res = await REPORT_API.post(`export/reports`, query, {
    responseType: "blob",
  });
  return res;
};

export const getWebFeeReport = async (query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.post(
    `web-order-fee?page=${pageIndex}&per_page=${pageSize}`,
    query,
    {},
  );
  return res.data;
};

export const getWebFeeReportExport = async (query) => {
  const res = await API.post(`export/web-order-fee`, query);
  return res.data;
}
